import React, {ReactElement} from 'react'

import styles from './index.module.scss'

interface PlateProps {
    title: string,
    active?: boolean,
    icon?: ReactElement,
    filled?: boolean,
    accentColor?: string,
}

const hexToRgba = (hex: string, alpha: number) => {
    const normalized = hex.replace('#', '')
    const full = normalized.length === 3
        ? normalized.split('').map(c => c + c).join('')
        : normalized
    const r = parseInt(full.slice(0, 2), 16)
    const g = parseInt(full.slice(2, 4), 16)
    const b = parseInt(full.slice(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export default function Plate({ title, active, icon, filled, accentColor}: PlateProps){
    const style: React.CSSProperties = {}

    if (filled) {
        style.color = '#282831'
        if (accentColor) {
            style.background = hexToRgba(accentColor, 0.1)
        } else {
            style.background = '#F6F5F9'
        }
    } else if (active) {
        // Field is "active" (e.g. its dropdown is open) but nothing picked yet:
        // keep the resting background, darken the label to #282831 (the icon is
        // set to #64617E by each picker).
        style.color = '#282831'
        style.background = '#FAF9FC'
    }

    return (
        <div className={styles.plate} style={style}>
            {icon}
            <p className={styles.plate__text}>{title}</p>
        </div>
    )
}
